// Eventos de Google Analytics 4 (registro, checkout, compra, test).
// Las conversiones de Google Ads (adsConversions.ts, flow.retorno.tsx) usan `send_to: AW-…`
// y no llegan a GA4; por eso estos eventos se envían aparte, solo a la propiedad de GA.
// Seguro: si falta el ID de GA o gtag no está cargado, no hace nada.

const GA_ID = import.meta.env.VITE_GA_MEASUREMENT_ID as string | undefined;

type Params = Record<string, string | number | boolean | undefined | Record<string, unknown>[]>;

/**
 * Envía un evento a GA4. Con `onceKey`, lo envía una sola vez por navegador
 * (evita duplicados al recargar la página).
 */
export function trackGa(event: string, params: Params = {}, onceKey?: string) {
  if (!GA_ID || typeof window === "undefined" || typeof window.gtag !== "function") return;
  const storageKey = onceKey ? `ga_${event}_${onceKey}` : null;
  if (storageKey) {
    try {
      if (window.localStorage.getItem(storageKey) === "sent") return;
    } catch {
      // localStorage puede no estar disponible; igual enviamos.
    }
  }
  window.gtag("event", event, { ...params, send_to: GA_ID } as never);
  if (storageKey) {
    try {
      window.localStorage.setItem(storageKey, "sent");
    } catch {
      // ignore
    }
  }
}
